<template>
  <div class="profile-container">
    here will be address stuiff
  </div>
</template>

<script>
export default {
  name: "profile-addresses",
  props: { user: Object }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
</style>
